import store from '../store/index'
import {router}  from '../router'
import { getAuthorizeLink } from '../api/authorize'
import { erpLogin } from '../api/authorize'
import { getSysConfig } from '../api/sys'
import bus from '../util/eventBus'
import qywxUtil from '../util/jweixin/index'
import { Dialog,Toast  } from 'vant';

var isSysInit = false;

var loadsSysConfig = async function(){
    return new Promise(async (res,rej) => {
      try
      {
        var data = await getSysConfig();
        res(data.data);
      }
      catch(e){
        console.error(`获取系统配置项失败! ${e}`,5)
        rej('获取系统配置项失败!');
      }
    });
}

var  sysInit = async function sysInit(){
  var config = await loadsSysConfig();

  store.commit('app/SET_SYSCONFIG', config);
  isSysInit = true;
}

var  wechatLogin = async function wechatLogin(){
     //普通服务器
     let token = store.state.authorize.token || null;
     //如果有Token，不需要重新登录
     if(!token){

       if('development' == process.env.NODE_ENV || this.$isDebug){
         router.push('/callback?code=123');
         return;
       }
       
       let data = await getAuthorizeLink();
       if(data.code != 200){
         Dialog.alert({
           message: data.message,
         });
         return;
       }
 
       window.location.href =  data.data
     }
     else{
      router.push('/home');
     }
       
}

var defaultLogin = () => {
  //普通服务器
  let token = store.state.authorize.token || null;
  //如果有Token，不需要重新登录
  if(token){
   router.push('/home');
  }
}

var scan =  () => {
  if(!store.state.app.sysConfig.useWechatApi){
    return new Promise((res,rej)=>{
      bus.$emit('scanDialogOpen',o=>{
        res(o);
      });
    })
  }
  else{
    return new Promise(async (res,rej)=>{
      var resp = await qywxUtil.scanQRCode();  
      var result = decodeURIComponent(encodeURIComponent(resp.resultStr).replace('%EF%BB%BF',''));

      res(result);
    })
  }
}

var photo = () =>{
  if(!store.state.app.sysConfig.useWechatApi){

  }
  else{
    return new Promise(async (res,rej)=>{
      var resp = await qywxUtil.photo(); 
      res(resp);
    })
  }
}

var tool = {
  removeLastChar:(str,char)=>{
     
    if(str.length == 0) return str;

    if(str[str.length-1] == char) return str.toString().substr(0,a.length-1)
  }
}

var dialog = {
  showConfirmDialog(title,message){
		return new Promise((res,rej)=>{
      Dialog.confirm({
        title: title,
        message:message,
      })
      .then(() => {
        res('ok');
      })
		});
	},
  showToastDialog(){

  }
}

export default {
    sysInit:sysInit,
    isSysInit:isSysInit,
    wechatLogin:wechatLogin,
    defaultLogin:defaultLogin,
    scan:scan,
    photo:photo,
    tool:tool,
    dialog:dialog
}